// ContactUsForm.js
import React from "react";

export default function ContactUsForm({
  vehicleReg,
  onCancel,
  onSubmitted,
  isPosting,
  profile,
  setProfile,
}) {
  const [errors, setErrors] = React.useState({});

  const { fullName = "", telephone = "", email = "" } = profile || {};

  function validate() {
    const errs = {};
    if (!fullName.trim()) errs.fullName = "Please enter your full name";
    if (!telephone.trim()) errs.telephone = "Please enter a phone number";
    if (!email.trim() || !/^\S+@\S+\.\S+$/.test(email))
      errs.email = "Enter a valid email";

    setErrors(errs);
    return Object.keys(errs).length === 0;
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (!validate()) return;

    const payload = {
      type: "contactUs",
      vehicleReg,
      fullName,
      telephone,
      email,
      submittedAt: new Date().toISOString(),
    };

    onSubmitted?.(payload);
  }

  return (
    <form onSubmit={handleSubmit} style={formStyles.form}>
      <div style={formStyles.header}>Your Contact Details</div>

      <label style={formStyles.label}>
        Full name
        <input
          style={formStyles.input}
          value={fullName}
          onChange={(e) =>
            setProfile((p) => ({ ...p, fullName: e.target.value }))
          }
        />
        {errors.fullName && (
          <div style={formStyles.error}>{errors.fullName}</div>
        )}
      </label>

      <label style={formStyles.label}>
        Telephone
        <input
          style={formStyles.input}
          value={telephone}
          onChange={(e) =>
            setProfile((p) => ({ ...p, telephone: e.target.value }))
          }
        />
        {errors.telephone && (
          <div style={formStyles.error}>{errors.telephone}</div>
        )}
      </label>

      <label style={formStyles.label}>
        Email
        <input
          type="email"
          style={formStyles.input}
          value={email}
          onChange={(e) => setProfile((p) => ({ ...p, email: e.target.value }))}
        />
        {errors.email && <div style={formStyles.error}>{errors.email}</div>}
      </label>

      <div style={formStyles.actions}>
        <button
          type="button"
          onClick={onCancel}
          style={formStyles.secondaryBtn}
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={isPosting}
          style={formStyles.primaryBtn}
        >
          {isPosting ? "Submitting…" : "Submit"}
        </button>
      </div>
    </form>
  );
}

const formStyles = {
  form: {
    border: "1px solid #e2e8f0",
    borderRadius: 12,
    padding: 12,
    background: "#fff",
  },
  header: {
    fontWeight: 700,
    marginBottom: 8,
  },
  label: {
    display: "block",
    fontSize: 12,
    color: "#334155",
    marginBottom: 8,
  },
  input: {
    width: "100%",
    marginTop: 4,
    padding: "8px 10px",
    border: "1px solid #cbd5e1",
    borderRadius: 8,
    fontSize: 14,
    outline: "none",
  },
  error: {
    marginTop: 4,
    color: "#b91c1c",
    fontSize: 12,
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 8,
    marginTop: 8,
  },
  primaryBtn: {
    background: "#0f172a",
    color: "#fff",
    border: "none",
    borderRadius: 10,
    padding: "8px 12px",
    cursor: "pointer",
    fontWeight: 600,
  },
  secondaryBtn: {
    background: "#f1f5f9",
    color: "#0f172a",
    border: "1px solid #e2e8f0",
    borderRadius: 10,
    padding: "8px 12px",
    cursor: "pointer",
    fontWeight: 600,
  },
};
